'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleFromJS = undefined;

var _immutable = require('immutable');

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _updateIn = require('transmute/updateIn');

var _updateIn2 = _interopRequireDefault(_updateIn);

var _Rule = require('../records/Rule');

var _Rule2 = _interopRequireDefault(_Rule);

var _SpecificTeamsAssignment = require('../records/SpecificTeamsAssignment');

var _SpecificTeamsAssignment2 = _interopRequireDefault(_SpecificTeamsAssignment);

var _SpecificTeamMembersAssignment = require('../records/SpecificTeamMembersAssignment');

var _SpecificTeamMembersAssignment2 = _interopRequireDefault(_SpecificTeamMembersAssignment);

var _OwnerAssignment = require('../records/OwnerAssignment');

var _OwnerAssignment2 = _interopRequireDefault(_OwnerAssignment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specificTeamMembersAssignmentFromJS = function specificTeamMembersAssignmentFromJS(assignment) {
  if (!assignment) {
    return null;
  }

  if ((0, _getIn2.default)(['responderIds'], assignment)) {
    return (0, _SpecificTeamMembersAssignment2.default)((0, _updateIn2.default)(['responderIds'], function (responderIds) {
      return (0, _immutable.List)(responderIds);
    }, assignment));
  }
  return (0, _SpecificTeamMembersAssignment2.default)(assignment);
};

var specificTeamsAssignmentFromJS = function specificTeamsAssignmentFromJS(assignment) {
  if (!assignment) {
    return null;
  }

  if ((0, _getIn2.default)(['teamIds'], assignment)) {
    return (0, _SpecificTeamsAssignment2.default)((0, _updateIn2.default)(['teamIds'], function (teamIds) {
      return (0, _immutable.List)(teamIds);
    }, assignment));
  }
  return (0, _SpecificTeamsAssignment2.default)(assignment);
};

var ownerAssignmentFromJS = function ownerAssignmentFromJS(assignment) {
  if (!assignment) {
    return null;
  }

  return (0, _OwnerAssignment2.default)((0, _pipe2.default)((0, _updateIn2.default)(['specificTeamMembersAssignment'], specificTeamMembersAssignmentFromJS), (0, _updateIn2.default)(['specificTeamsAssignment'], specificTeamsAssignmentFromJS))(assignment));
};

var ruleFromJS = exports.ruleFromJS = function ruleFromJS(rule) {
  if (!rule) {
    return null;
  }

  return (0, _Rule2.default)((0, _pipe2.default)((0, _updateIn2.default)(['specificTeamMembersAssignment'], specificTeamMembersAssignmentFromJS), (0, _updateIn2.default)(['specificTeamsAssignment'], specificTeamsAssignmentFromJS), (0, _updateIn2.default)(['ownerAssignment'], ownerAssignmentFromJS))(rule));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/RuleFactory.js
// module id = 913
// module chunks = 2 3